import Vue from 'vue'

const resource = 'prefectures'

const getAll = (params = {}) => Vue.axios(`${resource}`, {params})

export default {
  getAll
}



// WEBPACK FOOTER //
// ./src/api/prefectures.js